import { render, staticRenderFns } from "./addPriSimulationControlGroupModel.vue?vue&type=template&id=3467cdc8&scoped=true"
import script from "./addPriSimulationControlGroupModel.vue?vue&type=script&lang=js"
export * from "./addPriSimulationControlGroupModel.vue?vue&type=script&lang=js"
import style0 from "./addPriSimulationControlGroupModel.vue?vue&type=style&index=0&id=3467cdc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467cdc8",
  null
  
)

export default component.exports